<template>
  <v-container fluid class="pa-0 mo-bg" style="min-height: 87vh">
    <v-row class="ma-0 pa-0" align="center" justify="center">
      <v-col cols="12" sm="10" md="8" lg="7">
        <v-sheet
          class="mo-panel neo-surface elevation-3 rounded-xl mx-auto"
          max-width="820"
        >
          <v-toolbar flat dense class="mo-toolbar">
            <v-btn icon small class="white--text mr-1" @click="goBack">
              <v-icon color="white" small>mdi-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title class="white--text d-flex align-center">
              <v-icon left color="white" class="mr-2">mdi-factory</v-icon>
              Detail MEMO
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              small
              class="white--text"
              :disabled="loading"
              @click="refreshData"
            >
              <v-icon color="white" small :class="{ spin: loading }"
                >mdi-refresh</v-icon
              >
            </v-btn>
          </v-toolbar>
          <div class="position-relative">
            <canvas ref="bgCanvas" class="bg-canvas"></canvas>
            <div class="pa-6 neo-surface">
              <v-skeleton-loader
                v-if="loading"
                type="article, table, actions"
              />
              <div v-else>
                <v-row dense>
                  <v-col cols="12">
                    <div class="mo-header value emphasis-1">
                      {{ memo.no_memo }}
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">NO SO</div>
                    <div class="value">{{ memo.no_so }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">Tgl. Order</div>
                    <div class="value">
                      {{ memo.order_date }}
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">PLANT</div>
                    <div class="value">{{ memo.company_name }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">CUSTOMER</div>
                    <div class="value">{{ memo.customer }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">NO POLISI</div>
                    <div class="value">{{ memo.no_polisi }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">JENIS MOBIL</div>
                    <div class="value">{{ memo.jenis_mobil }}</div>
                  </v-col>
                  <!-- <v-col cols="6">
                    <div class="label">DRIVER</div>
                    <div class="value">{{ memo.driver_name }}</div>
                  </v-col> -->
                  <v-col cols="6">
                    <div class="label">Last Update</div>
                    <div class="value thick">
                      {{ memo.updated_at | moment('DD-MM-YYYY hh:mm:ss') }}
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label with-icon">
                      <v-icon small class="label-icon">mdi-list-status</v-icon>
                      <span>Status</span>
                    </div>
                    <div class="value">
                      <v-chip
                        small
                        label
                        class="white--text text-uppercase"
                        :color="statusInfo.color"
                      >
                        {{ statusInfo.label }}
                      </v-chip>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">Nomor SJ</div>
                    <div class="value thick">
                      {{ memo.sj_name }}
                    </div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12">
                    <v-simple-table dense class="summary-table">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">No.</th>
                            <th class="text-left">Produk</th>
                            <th class="text-right">Qty Demand</th>
                            <th class="text-right">Total Muat</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(r, i) in memo.items"
                            :key="'m-' + i"
                            class="clickable-row"
                            @click="getItemsDetail(r)"
                            @keydown.enter.prevent="getItemsDetail(r)"
                            @keydown.space.prevent="getItemsDetail(r)"
                            tabindex="0"
                          >
                            <td>{{ i + 1 }}</td>
                            <td>{{ r.nama }}</td>
                            <td class="text-right">
                              {{ formatNumber(r.qty) }} {{ r.uom }}
                            </td>
                            <td class="text-right">
                              {{ formatNumber(r.loaded_qty) }} {{ r.uom }}
                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td class="text-right strong">TOTAL AMDK</td>
                            <td class="text-right strong">
                              {{ formatNumber(totalAmdk) }}
                            </td>
                            <td class="text-right strong">
                              {{ formatNumber(totalLoadAmdk) }}
                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td class="text-right strong">TOTAL KARTON</td>
                            <td class="text-right strong">
                              {{ formatNumber(totalKarton) }}
                            </td>
                            <td class="text-right strong">
                              {{ formatNumber(totalLoadKarton) }}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
                <v-row class="mt-4" dense>
                  <!-- <v-col cols="12">
                    <v-btn block class="neo-btn" @click="openScanPallet"
                      >SCAN PASSET</v-btn
                    >
                  </v-col> -->
                  <v-col cols="12" class="mt-1">
                    <v-btn block class="neo-btn" @click="printMemo"
                      >PRINT ULANG</v-btn
                    >
                  </v-col>
                  <v-col cols="12" class="mt-1" v-if="memo.status == 0 || memo.status == 1">
                    <v-btn block class="neo-btn" @click="submitMemo"
                      >SUBMIT</v-btn
                    >
                  </v-col>
                  <v-col cols="12" class="mt-1" v-if="memo.status == -1">
                    <v-btn block class="neo-btn" @click="setDraftMemo"
                      >SET DRAFT</v-btn
                    >
                  </v-col>
                  <v-col cols="12" class="mt-1" v-if="memo.status != -1">
                    <v-btn block class="neo-btn" @click="cancelDialogMemo"
                      >CANCEL MEMO</v-btn
                    >
                  </v-col>
                  <v-col cols="12" class="mt-1">
                    <v-btn block class="neo-btn" @click="cancelMemo"
                      >KEMBALI</v-btn
                    >
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </v-sheet>
      </v-col>
    </v-row>

    <!-- Notif sukses simpan -->
    <v-dialog v-model="dialogSaved" max-width="420">
      <v-card class="neo-surface pa-5 text-center">
        <v-icon color="#43A047" large>mdi-check-circle</v-icon>
        <div class="mt-2 strong">Data berhasil disimpan.</div>
        <div class="mt-3">
          <v-btn class="neo-btn" @click="onSubmitOk">OK</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Notif selesai -->
    <v-dialog v-model="dialogConfirm" max-width="420">
      <v-card class="neo-surface pa-5 text-center">
        <v-icon color="orange" large>mdi-alert</v-icon>
        <div class="mt-2 strong">Anda yakin data sudah sesuai</div>
        <div class="mt-3">
          <v-btn class="neo-btn" @click="confirmSubmit">YA, LANJUTKAN</v-btn>
          <v-btn class="neo-btn" @click="cancelSubmit">BATAL</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSetDraft" max-width="420">
      <v-card class="neo-surface pa-5 text-center">
        <v-icon color="orange" large>mdi-alert</v-icon>
        <div class="mt-2 strong">
          Anda yakin ingin merubah status menjadi draft ?
        </div>
        <div class="mt-3">
          <v-btn class="neo-btn" @click="confirmSetDraft">YA, LANJUTKAN</v-btn>
          <v-btn class="neo-btn" @click="cancelSubmit">BATAL</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCancel" max-width="420">
      <v-card class="neo-surface pa-5 text-center">
        <v-icon color="orange" large>mdi-alert</v-icon>
        <div class="mt-2 strong">
          Anda yakin ingin merubah status menjadi cancel ?
        </div>
        <div class="mt-3">
          <v-btn class="neo-btn" @click="confirmCancel">YA, LANJUTKAN</v-btn>
          <v-btn class="neo-btn" @click="cancelSubmit">BATAL</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!-- <production-scanner
      v-model="dialogScanPallet"
      title="Scan Form Pallet"
      input-label="Scan/Tempel Nomor Form Pallet"
      :action-label="'Cari'"
      :persistent="false"
      :auto-close-on-scan="true"
      :auto-emit-on-scan="true"
      @scanned="handlePalletScanned"
    /> -->
  </v-container>
</template>

<script>
import axios from 'axios'
import buildType from '../../../../services/buildType'
import { mapMutations } from 'vuex'

const createEmptyMemo = (memoNo = '') => ({
  id: null,
  no_memo: memoNo,
  no_so: '-',
  total_order: 0,
  plant: '-',
  company_name: '-',
  customer: '-',
  jenis_mobil: '-',
  no_polisi: '-',
  driver_name: '-',
  order_date: '-',
  updated_at: null,
  sj_name: null,
  status: null,
  items: [],
  rawItems: []
})

export default {
  name: 'MemoDetail',
  components: {
    // ProductionScanner: () =>
    //   import('../../../home/components/ProductionScanner.vue')
  },
  data() {
    return {
      build: process.env.VUE_APP_BUILD_TYPE,
      odooApi: buildType.apiURL('odoo'),
      passedApi: buildType.apiURL('passed'),
      loading: true,
      memo: createEmptyMemo(),
      dialogScanPallet: false,
      dialogSaved: false,
      dialogConfirm: false,
      dialogSetDraft: false,
      dialogCancel: false
    }
  },
  computed: {
    statusInfo: function () {
      var raw = (this.memo && this.memo.status) || ''
      var s = String(raw).toLowerCase()
      // Only three MO states: draft, confirmed, done
      if (s == 0) return { label: 'Draft', color: 'grey darken-1' }
      if (s == 1) return { label: 'Submitted', color: 'blue' }
      if (s == 2) return { label: 'Done', color: 'green' }
      if (s == -1) return { label: 'Cancel', color: 'red' }
      return { label: raw || '-', color: 'grey' }
    },
    totalMemo() {
      return (this.memo.items || []).reduce(
        (acc, item) => acc + Number(item.qty || 0),
        0
      )
    },
    totalAmdk() {
      const arr = this.memo.items || []
      return arr
        .filter((x) =>
          String(x.nama || '')
            .toLowerCase()
            .includes('amdk')
        )
        .reduce((a, b) => a + Number(b.qty || 0), 0)
    },
    totalLoadAmdk() {
      const arr = this.memo.items || []
      return arr
        .filter((x) =>
          String(x.nama || '')
            .toLowerCase()
            .includes('amdk')
        )
        .reduce((a, b) => a + Number(b.loaded_qty || 0), 0)
    },
    totalKarton() {
      const arr = this.memo.items || []
      return arr
        .filter((x) =>
          String(x.nama || '')
            .toLowerCase()
            .includes('karton')
        )
        .reduce((a, b) => a + Number(b.qty || 0), 0)
    },
    totalLoadKarton() {
      const arr = this.memo.items || []
      return arr
        .filter((x) =>
          String(x.nama || '')
            .toLowerCase()
            .includes('karton')
        )
        .reduce((a, b) => a + Number(b.loaded_qty || 0), 0)
    }
  },
  watch: {
    '$route.fullPath'() {
      this.fetchMemoDetail()
    }
  },
  methods: {
    ...mapMutations(['setMemoItem']),
    async printMemo() {
      try {
        const { data: payload } = await axios.post(
          `${this.passedApi}loading_memo/print`,
          {
            memo_id: this.memo?.id
          }
        )

        const ok = payload?.status_code == '00'
        if (!ok) {
          this.showApiWarning(payload, 'Gagal print memo')
          return
        }

        this.showApiSuccess(payload, 'Berhasil print memo')
      } catch (error) {
        console.error('print memo error', error)
        if (this.$swal) {
          this.$swal.fire('Error', 'Gagal print memo', 'error')
        }
      }
    },
    goBack() {
      if (this.$router) this.$router.back()
    },
    onSubmitOk() {
      this.dialogSaved = false
    },
    // openScanPallet() {
    //   this.dialogScanPallet = true
    // },
    handlePalletScanned(code) {
      const no = (code || '').toString().trim()
      if (!no) return
      if (no.length >= 3) {
        this.$router &&
          this.$router.push({
            name: 'lotCheckerNormalPalletDetail',
            query: { no }
          })
      } else {
        this.$swal && this.$swal.fire('Info', 'Data tidak ditemukan', 'warning')
      }
    },
    cancelMemo() {
      this.$router && this.$router.push({ name: 'lotChecker' })
    },
    cancelDialogMemo() {
      this.dialogCancel = true
    },
    setDraftMemo() {
      this.dialogSetDraft = true
    },
    submitMemo() {
      this.dialogConfirm = true
    },
    escapeHtml(text) {
      if (text == null) return ''
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    },
    buildApiErrorMessage(payload, defaultMessage = 'Terjadi kesalahan') {
      const baseMessage = payload?.status_msg || defaultMessage
      if (
        payload?.status_msg === 'Parameter value has problem' &&
        Array.isArray(payload?.error_msg)
      ) {
        const detailMessages = payload.error_msg
          .map((item) => item?.msg)
          .filter(Boolean)
        if (detailMessages.length) {
          const items = detailMessages
            .map((msg) => `<li>${this.escapeHtml(msg)}</li>`)
            .join('')
          return `${this.escapeHtml(
            baseMessage
          )}<ul style="margin:8px 0 0 16px;padding-left:16px;text-align:left;">${items}</ul>`
        }
      }
      return baseMessage
    },
    showApiWarning(payload, defaultMessage = 'Terjadi kesalahan') {
      if (!this.$swal) return
      const message = this.buildApiErrorMessage(payload, defaultMessage)
      this.$swal.fire('Info', message, 'warning')
    },
    showApiSuccess(payload, defaultMessage = 'Berhasil') {
      if (!this.$swal) return
      const message = payload?.status_msg || defaultMessage
      this.$swal.fire('Success', message, 'success')
    },
    async confirmCancel() {
      this.dialogCancel = false
      // TO DO: fetch api submit to odoo heree
      this.loading = true
      try {
        const { data: payload } = await axios.post(
          `${this.passedApi}loading_memo/cancel`,
          {
            memo_id: this.memo?.id
          }
        )

        const ok = payload?.status_code === '00'
        if (!ok) {
          this.showApiWarning(payload, 'Gagal cancel memo')
          return
        }

        this.showApiSuccess(payload, 'Berhasil cancel memo')
        // this.dialogCancel = true
        await this.fetchMemoDetail()
      } catch (error) {
        console.error('CancelMemo error', error)
        if (this.$swal) {
          this.$swal.fire('Error', 'Gagal cancel', 'error')
        }
      } finally {
        this.loading = false
      }
    },
    async confirmSetDraft() {
      this.dialogSetDraft = false
      // TO DO: fetch api submit to odoo heree
      this.loading = true
      try {
        const { data: payload } = await axios.post(
          `${this.passedApi}loading_memo/set_to_draft`,
          {
            memo_id: this.memo?.id
          }
        )

        const ok = payload?.status_code === '00'
        if (!ok) {
          this.showApiWarning(payload, 'Gagal set draft memo')
          return
        }

        this.showApiSuccess(payload, 'Berhasil set draft memo')
        // this.dialogSetDraft = true
        await this.fetchMemoDetail()
      } catch (error) {
        console.error('setDraftMemo error', error)
        if (this.$swal) {
          this.$swal.fire('Error', 'Gagal setDraft memo', 'error')
        }
      } finally {
        this.loading = false
      }
    },
    async confirmSubmit() {
      this.dialogConfirm = false
      // TO DO: fetch api submit to odoo heree
      this.loading = true
      try {
        const { data: payload } = await axios.post(
          `${this.passedApi}memo_pallet/submit_to_odoo`,
          {
            memo_id: this.memo?.id
          }
        )

        const ok = payload?.status_code == '00'
        if (!ok) {
          this.showApiWarning(payload, 'Gagal submit memo ke odoo')
          return
        }

        this.showApiSuccess(payload, 'Berhasil submit memo ke odoo')
        this.dialogSaved = true
        await this.fetchMemoDetail()
      } catch (error) {
        console.error('submitMemo error', error)
        if (this.$swal) {
          this.$swal.fire('Error', 'Gagal submit memo ke odoo', 'error')
        }
      } finally {
        this.loading = false
      }
    },
    cancelSubmit() {
      this.dialogConfirm = false
      this.dialogSetDraft = false
      this.dialogCancel = false
    },
    drawBackground() {
      const c = this.$refs.bgCanvas
      if (!c) return
      const w = c.parentElement.clientWidth
      const h = 220
      c.width = w
      c.height = h
      const x = c.getContext('2d')
      x.clearRect(0, 0, w, h)
      const g1 = x.createRadialGradient(
        w * 0.25,
        h * 0.5,
        10,
        w * 0.25,
        h * 0.5,
        170
      )
      g1.addColorStop(0, 'rgba(144,202,249,.35)')
      g1.addColorStop(1, 'rgba(144,202,249,0)')
      x.fillStyle = g1
      x.beginPath()
      x.arc(w * 0.25, h * 0.55, 150, 0, Math.PI * 2)
      x.fill()
      const g2 = x.createRadialGradient(
        w * 0.8,
        h * 0.2,
        10,
        w * 0.8,
        h * 0.2,
        150
      )
      g2.addColorStop(0, 'rgba(165,214,167,.35)')
      g2.addColorStop(1, 'rgba(165,214,167,0)')
      x.fillStyle = g2
      x.beginPath()
      x.arc(w * 0.8, h * 0.25, 140, 0, Math.PI * 2)
      x.fill()
    },

    formatNumber(n) {
      if (n == null || n === '') return '0'
      const parsed = Number(n)
      if (Number.isNaN(parsed)) return String(n)
      try {
        return parsed.toLocaleString('id-ID')
      } catch (e) {
        return String(parsed)
      }
    },
    formatDateTime(value) {
      if (!value) return '-'
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return String(value)
      const pad = (num) => (num < 10 ? `0${num}` : String(num))
      return (
        `${pad(date.getDate())}-${pad(
          date.getMonth() + 1
        )}-${date.getFullYear()}` +
        ` ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
          date.getSeconds()
        )}`
      )
    },
    transformMemoItems(list) {
      if (!Array.isArray(list)) return []
      return list.map((item) => ({
        id: item.id,
        nama: item.product_name || item.description || 'Produk',
        qty: Number(item.qty || 0),
        loaded_qty: Number(item.loaded_qty || 0),
        uom: item.uom_name || '-',
        productId: item.product_id != null ? String(item.product_id) : '',
        productCode: item.product_code || '',
        raw: item
      }))
    },
    getItemsDetail(item) {
      if (!item) return
      const query = { id: item.id }
      if (this.$router) {
        const savedData = {
          id: this.memo.id,
          memo_id: item.raw.memo_id,
          product_id: item.productId,
          product_code: item.productCode,
          product_name: item.nama,
          so_no: this.memo.no_so,
          company_name: this.memo.company_name,
          order_date: this.memo.order_date,
          customer: this.memo.customer,
          no_memo: this.memo.no_memo,
          qty: item.qty,
          loaded_qty: item.loaded_qty,
          uom: item.uom
        }
        this.setMemoItem(savedData)
        this.$router.push({
          name: 'lotCheckerNormalMemoItemDetail',
          query
        })
      }
    },
    async fetchMemoDetail() {
      const memoNo = this.getMemoNoFromRoute()
      if (!memoNo) {
        this.loading = false
        this.$swal &&
          this.$swal.fire('Info', 'Nomor memo tidak tersedia', 'warning')
        return
      }

      const url = `${
        this.passedApi
      }loading_memo/search?memo_no=${encodeURIComponent(memoNo)}`
      this.loading = true
      try {
        const response = await axios.get(url)
        const payload = response && response.data
        if (payload && payload.status_code === '00' && payload.data) {
          const memoData = payload.data
          const items = this.transformMemoItems(memoData.memo_items)
          const nextMemo = createEmptyMemo(memoData.memo_no || memoNo)
          nextMemo.id = memoData.id || null
          nextMemo.no_so = memoData.so_no || '-'
          nextMemo.company_name = memoData.company_name || '-'
          nextMemo.plant = nextMemo.company_name
          nextMemo.customer = memoData.customer_name || '-'
          nextMemo.jenis_mobil = memoData.vehicle_model_name || '-'
          nextMemo.driver_name = memoData.driver_name || '-'
          nextMemo.no_polisi = memoData.license_plate_no || '-'
          nextMemo.updated_at = memoData.updated_at || '-'
          nextMemo.sj_name = memoData.sj_name || '-'
          nextMemo.status = memoData.status
          nextMemo.order_date = this.formatDateTime(memoData.order_date)
          nextMemo.items = items
          nextMemo.total_order = items.reduce(
            (total, item) => total + Number(item.qty || 0),
            0
          )
          nextMemo.rawItems = Array.isArray(memoData.memo_items)
            ? memoData.memo_items
            : []
          this.memo = nextMemo
        } else {
          this.memo = createEmptyMemo(memoNo)
          this.showApiWarning(payload, 'Data memo tidak ditemukan')
        }
      } catch (error) {
        console.error('fetchMemoDetail error', error)
        this.$swal &&
          this.$swal.fire('Error', 'Gagal mengambil data memo', 'error')
        this.memo = createEmptyMemo(memoNo)
      } finally {
        this.loading = false
      }
    },
    getMemoNoFromRoute() {
      const query = (this.$route && this.$route.query) || {}
      const memoNo =
        (query.memoNo !== undefined ? query.memoNo : query.id) || ''
      return memoNo.toString().trim()
    },
    refreshData() {
      this.fetchMemoDetail()
    }
  },
  mounted() {
    this.$nextTick(() => this.drawBackground())
    window.addEventListener('resize', this.drawBackground)
    this.fetchMemoDetail()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.drawBackground)
  }
}
</script>

<style scoped>
.mo-header {
  text-align: center;
  position: relative;
  min-height: 28px;
  padding-top: 2px;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
  color: #37474f;
}
.mo-toolbar {
  background: linear-gradient(135deg, #90caf9 0%, #a5d6a7 100%);
}

.mo-bg {
  background: linear-gradient(180deg, #fafcff 0%, #ffffff 70%);
}
.mo-panel {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
}
.bg-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 220px;
  pointer-events: none;
}
.neo-surface {
  --bg: #f3f6fb;
  background: var(--bg) !important;
}
.label {
  color: #6b7280;
  font-size: 0.85rem;
  margin-bottom: 2px;
}
.label.with-icon {
  display: flex;
  align-items: center;
}
.label-icon {
  margin-right: 6px;
  color: #64b5f6; /* soft primary accent */
}
.value {
  color: #263238;
}
.value.uppercase {
  text-transform: uppercase;
}
.value.strong {
  font-weight: 700;
}
.value.emphasis-1 {
  font-size: 1.25rem;
  font-weight: 700;
}
.value.emphasis-2 {
  font-size: 1.15rem;
  font-weight: 600;
}
.value.thick {
  font-size: 0.95rem;
  font-weight: 400;
}
.neo-btn.v-btn {
  --bg: #f3f6fb;
  --hi: rgba(255, 255, 255, 0.95);
  background: var(--bg) !important;
  color: #263238 !important;
  border-radius: 14px !important;
  padding: 10px 16px !important;
  text-transform: none;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.08), -8px -8px 16px var(--hi) !important;
}
.neo-btn.v-btn::before {
  background-color: transparent !important;
}
.summary-table thead th {
  background: linear-gradient(
    135deg,
    rgba(144, 202, 249, 0.25) 0%,
    rgba(165, 214, 167, 0.25) 100%
  );
  font-weight: 600;
  color: #37474f;
}
.summary-table td,
.summary-table th {
  border: 1px solid rgba(144, 202, 249, 0.25);
}

.neo-btn.save-btn {
  --bg: #e5f6eb;
  --hi: rgba(255, 255, 255, 0.95);
  color: #2e7d32 !important;
  border: 1px solid rgba(76, 175, 80, 0.2);
}

.neo-btn.cancel-btn {
  --bg: #fdeced;
  --hi: rgba(255, 255, 255, 0.95);
  color: #c62828 !important;
  border: 1px solid rgba(198, 40, 40, 0.2);
}

.dialog-actions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  gap: 16px;
  margin-top: 24px;
}
.clickable-row {
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.clickable-row:hover,
.clickable-row:focus {
  background: rgba(144, 202, 249, 0.12);
}
.clickable-row:focus {
  outline: none;
  box-shadow: inset 0 0 0 1px rgba(144, 202, 249, 0.6);
}
.warning-icon {
  color: #f57c00;
}
</style>
